<template>
  <BreadCrumb PageTitle="Manage Reviews" />
  <ManageReviews />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import ManageReviews from "../../template-components/Ecommerce/ManageReviews/ManageReviews.vue";

export default defineComponent({
  name: "ManageReviewsPage",
  components: {
    BreadCrumb,
    ManageReviews,
  },
});
</script>